import React from 'react';
import { useTranslation } from 'react-i18next';

import FromData from './components/FormSend';
import cls from './sendRequest.module.scss';

function SendRequest() {
  const { t } = useTranslation();
  return (
    <div className={cls.form_send_page}>
      <h1 className={cls.form_send_page_title}>
        {t('event.eventAction.addHelpDescriptionResult')}
      </h1>
      <FromData page />
      <span className={cls.form_send_page_about}>
        {t('event.eventAction.addHelpTitlePopabResult')}
      </span>
    </div>
  );
}
export default SendRequest;
